import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

interface Contratto {
  id: number;
  contratto: string;
}

export const useGetContratti = () => {
  const [contratti, setContratti] = useState<Contratto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContratti = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/contratti`);
        setContratti(response.data);
      } catch (error) {
        setError("Impossibile recuperare i contratti");
      } finally {
        setLoading(false);
      }
    };

    fetchContratti();
  }, []);

  return { contratti, loading, error };
};

export default useGetContratti;